"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORT_DIR_DESC = exports.SORT_DIR_ASC = void 0;
// (C) 2019 GoodData Corporation
exports.SORT_DIR_ASC = "asc";
exports.SORT_DIR_DESC = "desc";
//# sourceMappingURL=sort.js.map